import { NewRoutingRule, RoutingRuleAssignmentTargetType } from '@mews-commander/data-access';
import { getCompanyName, getCustomerFullName } from '@mews-commander/legacy-entities/src/ducks';
import { isAccountIdCompany } from '@mews-commander/legacy-entities/src/selectors/bills';
import { useCommanderSelector } from '@mews-commander/utils';

export const useBillingAutomationOwnerName = (accountId: string, routingRule?: NewRoutingRule | null) => {
    const isCompany = useCommanderSelector((state) => (accountId ? isAccountIdCompany(state, { accountId }) : false));
    const selector = isCompany ? getCompanyName : getCustomerFullName;
    const ownerName = useCommanderSelector((state) => (accountId ? selector(state, { id: accountId }) : undefined));

    if (routingRule?.assignmentTargetType === RoutingRuleAssignmentTargetType.CompanyAsOwner) {
        return routingRule.companiesWithRelations[0]?.companyName ?? '';
    }

    return ownerName || '';
};
